import { currentUrl, hiddenClasses, numberSystemDecimal, searchParams } from '../../common/consts';
import { CountryComponent } from '../../components/our-partners/country.component';
import { SwitcherComponent } from '../../base/switcher.component';

export class OurPartnersPage {
  private country: HTMLElement | null;
  private elementsWithFilterKinds: HTMLElement[];
  private currentSelectedCategory: number | string | null | undefined;
  private showMoreHtmlElement: HTMLElement | null;

  constructor(
    private switchers: HTMLElement[],
    private loader: HTMLElement | null
  ) {
    this.country = document.querySelector('[data-country="container"]');
    this.currentSelectedCategory = '';
    const elementsWithFilterKinds: NodeListOf<HTMLElement>
      = document.querySelectorAll('[data-elements-with-filter-kind]');

    this.elementsWithFilterKinds = Array.from(elementsWithFilterKinds);
    this.showMoreHtmlElement = document.querySelector('[data-show-more-elements-with-filter]')
  }

  public initialize(): void {
    const elementsWithFilter: HTMLElement | null = document.querySelector(`[data-elements-with-filter]`);

    if (elementsWithFilter && elementsWithFilter.dataset.elementsWithFilter === 'partners' && this.country) {
      const categoryId = searchParams.get('categoryId');
      const elementsWithFilterIdItems = Array.prototype.slice.call(document.querySelectorAll('[data-elements-with-filter-id]'));
      let categoryIdNumber = null;
      if (elementsWithFilterIdItems.length > 0) {

        const categoryElementId = elementsWithFilterIdItems[0].dataset.elementsWithFilterId;
        if ( categoryElementId) {
          categoryIdNumber = parseInt(categoryElementId, numberSystemDecimal);
        }
      }

      if (categoryId) {
        categoryIdNumber = parseInt(categoryId, numberSystemDecimal);
      }

      new CountryComponent(this.country, this.loader, this.switchers, categoryIdNumber, this.showMoreHtmlElement).initialize();
      const partnersCategoryDescription = document.querySelector('[data-partners-category-description]');

      if (this.elementsWithFilterKinds.length > 0) {
        this.elementsWithFilterKinds.forEach((kind, index: number) => {

          kind.addEventListener('click', (e: Event) => {

            e.stopImmediatePropagation();
            const elementsWithFilterKind = kind.dataset.elementsWithFilterKind;

            let path;
            if (elementsWithFilterKind && elementsWithFilterKind !== '-1') {
              searchParams.set('categoryName', elementsWithFilterKind);
              const categoryId =  kind.dataset.elementsWithFilterId;
              if (categoryId) {
                searchParams.set('categoryId', categoryId);
              }
              currentUrl.search = searchParams.toString();
              path = currentUrl.toString();
            } else {
              path = location.pathname;
            }
            history.pushState(null, '', path);
            this.categoryNavigate(kind, index);
            this.switchers.forEach((switcher: HTMLElement): void => {
              new SwitcherComponent(switcher).initialize();
            });
            if (elementsWithFilterKind && this.currentSelectedCategory !== elementsWithFilterKind) {
              this.currentSelectedCategory = elementsWithFilterKind;
              this.initCountryComponent(kind);
            }
            const description = kind.dataset.elementsWithFilterDescription
              ? kind.dataset.elementsWithFilterDescription
              : '&nbsp;';
            if (description && partnersCategoryDescription) {
              partnersCategoryDescription.innerHTML = description;
            }
          });
          const categoryId = searchParams.get('categoryId');
          if (kind.dataset.elementsWithFilterId === categoryId) {
            const description = kind.dataset.elementsWithFilterDescription
              ? kind.dataset.elementsWithFilterDescription
              : '&nbsp;';
            if (description && partnersCategoryDescription) {
              partnersCategoryDescription.innerHTML = description;
            }
          }
        });
        if (partnersCategoryDescription) {
          partnersCategoryDescription.classList.remove(hiddenClasses.hidden);
        }
      }
    }

  }
  private categoryNavigate(kind: HTMLElement, index: number) {
    if (typeof kind.dataset.tabFilter !== 'undefined') {
      kind.classList.toggle('active');
      this.elementsWithFilterKinds.forEach((elementsWithFilterKind) => {
        elementsWithFilterKind.classList.remove('active');
      });
      this.elementsWithFilterKinds[index].classList.add('active');
    }
  }
  private initCountryComponent(kind: HTMLElement | null = null) {

    if (this.country) {

      let categoryId;
      if (kind) {
        const id = kind.dataset.elementsWithFilterId;
        if (id) {
          categoryId = parseInt(id, numberSystemDecimal);
        }
      }
      new CountryComponent(this.country, this.loader, this.switchers, categoryId, this.showMoreHtmlElement, true).initialize();
    }
  }
}
